import Home  from "./Home.vue";
import Policy from "./Policy.vue";
import Terms from "./Terms.vue";
import RemoveAccount from "./RemoveAccount.vue";

export const routes = [
    { path: '/', component: Home },
    { path: '/policy', component: Policy },
    { path: '/terms', component: Terms },
    { path: '/remove-account', component: RemoveAccount },
]